"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 18h2v-8h-2zm0 4h2v-2h-2zM2 22h16V8h4V2z"
}), 'SignalCellularConnectedNoInternet4BarTwoTone');